module.exports = __webpack_public_path__ + "img/card_null.ed3f3b78.png";